import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsFacilityLocationAddParm } from "./wsFacilityLocationAddParm";
import { wsFacilityLocationEditParm } from "./wsFacilityLocationEditParm";

@Injectable()
export class DataService_facilitylocationmaint {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/FacilityLocationSelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationToggleActive
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationToggleActive(FacilityLocationID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/FacilityLocationToggleActive";

		var promise$ = this.httpclientService.post(url, FacilityLocationID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SchoolFacilitySelectList
	//
	//-----------------------------------------------------------------------------------------------------
	SchoolFacilitySelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "Visitor/SchoolFacilitySelectList";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationAdd
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationAdd(parms: wsFacilityLocationAddParm) {
		var postResult$ = new Subject();
		var url = "Visitor/FacilityLocationAdd";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	FacilityLocationEdit
	//
	//-----------------------------------------------------------------------------------------------------
	FacilityLocationEdit(parms: wsFacilityLocationEditParm) {
		var postResult$ = new Subject();
		var url = "Visitor/FacilityLocationEdit";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
